import React, { useEffect, useReducer, useState } from "react";
import {
  Box,
  Grid,
  Paper,
  Typography,
  Button,
  TextField,
  CircularProgress,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { updateUser } from "../../api/user";
import useSnackbar from "../../hooks/useSnackbar";
//import { makeStyles } from "@material-ui/core/styles";
import { makeStyles } from "@mui/styles";
import useErrorHandler from "../../hooks/useErrorHandler";
//import { createMuiTheme } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  profileBox: {
    color: "rgba(0, 0, 0, 0.87)",
    transition: "box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
    overflow: "break-word",
    borderRadius: "0.75rem",
    boxShadow:
      "rgba(0, 0, 0, 0.1) 0rem 0.25rem 0.375rem -0.0625rem, rgba(0, 0, 0, 0.06) 0rem 0.125rem 0.25rem -0.0625rem",
    overflow: "visible",
    marginTop: "50px",
    display: "flex",
    flexDirection: "column",
  },
  boxTitle: {
    marginTop: "-24px",
    marginLeft: "16px",
    marginRight: "16px",
    opacity: "1",
    background: "transparent",
    color: "rgb(52, 71, 103)",
    boxShadow: "none",
  },
  profileTitleBox: {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    background: "linear-gradient(195deg, #005480 , #0c7eb6 )",
    padding: "1rem 1rem 1rem",
    borderRadius: "0.5rem",
    boxShadow:
      "rgb(71 70 70 / 14%) 0rem 0.25rem 1.25rem 0rem, #eef7f866 0rem 0.4375rem 0.625rem -0.3125rem",
    color: "#fff",
    fontSize: "18px",
    fontWeight: "600",
  },
}));
const initialState = { editMode: false, suspense: false };
const localReducer = (state, action) => {
  switch (action.type) {
    case "EDIT-MODE":
      return { editMode: true, suspense: false };
    case "NORMAL-MODE":
      return { editMode: false, suspense: false };
    case "POST-EDIT":
      return { ...state, suspense: true };
    default:
      return state;
  }
};

export default function Profile() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const errorHandler = useErrorHandler();
  const snackbar = useSnackbar();
  const { data: profile } = useSelector((state) => state.user);
  const [isSubmit, setIsSubmit] = useState("");
  const [formErrors, setFormErrors] = useState({});
  const [state, localDispatch] = useReducer(localReducer, initialState);

  const [updateData, setUpdateData] = useState(getUpdatableData(profile));
  const handleInputChange = (e) => {
    setUpdateData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  useEffect(() => {
    if (state.editMode) setUpdateData(getUpdatableData(profile));
  }, [state.editMode]);

  const handleSubmit = (e) => {
    e.preventDefault();
    setFormErrors(validate(updateData));
    setIsSubmit(true);
  };
  const onUpdateFormSubmit = async () => {
    try {
      localDispatch({ type: "POST-EDIT" });
      await updateUser(updateData, profile.token);
      dispatch({ type: "UPDATE_SUCCESS", payload: updateData });
      snackbar.showSuccess("Profile Updated");
      localDispatch({ type: "NORMAL-MODE" });
    } catch (err) {
      errorHandler(err);
    }
  };

  useEffect(() => {
    if (Object.keys(formErrors).length === 0 && isSubmit) {
      onUpdateFormSubmit();
    }
  }, [formErrors]);
  const validate = (values) => {
    console.log("valuess==", values);
    const errors = {};
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
    if (!values.firstname) {
      errors.firstname = "First name is required!";
    }
    if (!values.lastname) {
      errors.lastname = "Last name is required!";
    }

    if (!values.address) {
      errors.address = "Address is required";
    }
    if (!values.address2) {
      errors.address2 = "Address is required";
    }
    if (!values.zipcode) {
      errors.zipcode = "Zip code is required";
    }

    if (!values.city) {
      errors.city = "City is required";
    }
    if (!values.state) {
      errors.state = "State is required";
    }
    if (!values.country) {
      errors.country = "Country is required";
    }

    if (!values.phone) {
      errors.phone = "Phone Number is required";
    } else if (values.phone.length < 10 || values.phone.length > 10) {
      errors.phone = "Please enter a valid 10-digit phone number";
    }
    return errors;
  };
  return (
    <Paper elevation={3} className={classes.profileBox}>
      <Box className={classes.boxTitle}>
        <Typography variant="h5" className={classes.profileTitleBox}>
          Your Profile
        </Typography>
      </Box>
      {state.editMode ? (
        <Box component="form" onSubmit={handleSubmit} p={2}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6} lg={4} xl={4}>
              <TextField
                fullWidth
                size="small"
                label="First name"
                value={updateData.firstname}
                onChange={handleInputChange}
                name="firstname"
                variant="outlined"
                error={Boolean(formErrors.firstname)}
                helperText={formErrors.firstname}
              />
            </Grid>
            <Grid item xs={12} md={6} lg={4} xl={4}>
              <TextField
                fullWidth
                size="small"
                label="Lastname"
                value={updateData.lastname}
                onChange={handleInputChange}
                name="lastname"
                variant="outlined"
                error={Boolean(formErrors.lastname)}
                helperText={formErrors.lastname}
              />
            </Grid>
            {/* <Grid item xs={12} md={6} lg={4} xl={4} >
                            <TextField type="email" fullWidth size="small" label="Email" value={updateData.email}
                                onChange={handleInputChange} name="email" variant="outlined"
                            />
                        </Grid> */}
            <Grid item xs={12} md={6} lg={4} xl={4}>
              <TextField
                type="tel"
                fullWidth
                size="small"
                label="Phone"
                value={updateData.phone}
                onChange={handleInputChange}
                name="phone"
                variant="outlined"
                inputProps={{ maxLength: 10 }}
                error={Boolean(formErrors.phone)}
                helperText={formErrors.phone}
              />
            </Grid>
            <Grid item xs={12} md={6} lg={4} xl={4}>
              <TextField
                fullWidth
                size="small"
                label="Address Line 1"
                value={updateData.address}
                onChange={handleInputChange}
                name="address"
                variant="outlined"
                error={Boolean(formErrors.address)}
                helperText={formErrors.address}
              />
            </Grid>
            <Grid item xs={12} md={6} lg={4} xl={4}>
              <TextField
                fullWidth
                size="small"
                label="Address Line 2"
                value={updateData.address2}
                onChange={handleInputChange}
                name="address2"
                variant="outlined"
                error={Boolean(formErrors.address2)}
                helperText={formErrors.address2}
              />
            </Grid>
            <Grid item xs={12} md={6} lg={4} xl={4}>
              <TextField
                fullWidth
                size="small"
                label="City"
                value={updateData.city}
                onChange={handleInputChange}
                name="city"
                variant="outlined"
                error={Boolean(formErrors.city)}
                helperText={formErrors.city}
              />
            </Grid>
            <Grid item xs={12} md={6} lg={4} xl={4}>
              <TextField
                fullWidth
                size="small"
                label="Zip Code"
                value={updateData.zipcode}
                onChange={handleInputChange}
                name="zipcode"
                variant="outlined"
                inputProps={{ maxLength: 7 }}
                error={Boolean(formErrors.zipcode)}
                helperText={formErrors.zipcode}
              />
            </Grid>
            <Grid item xs={12} md={6} lg={4} xl={4}>
              <TextField
                fullWidth
                size="small"
                label="State"
                value={updateData.state}
                onChange={handleInputChange}
                name="state"
                variant="outlined"
                error={Boolean(formErrors.state)}
                helperText={formErrors.state}
              />
            </Grid>
            <Grid item xs={12} md={6} lg={4} xl={4}>
              <TextField
                fullWidth
                size="small"
                label="Country"
                value={updateData.country}
                onChange={handleInputChange}
                name="country"
                variant="outlined"
                error={Boolean(formErrors.country)}
                helperText={formErrors.country}
              />
            </Grid>
            <Grid item xs={12} md={6} lg={12}>
              <Box display="flex" columnGap={1} justifyContent="flex-end">
                <Button
                  size="large"
                  variant="outlined"
                  onClick={() => {
                    localDispatch({ type: "NORMAL-MODE" });
                  }}
                  className="black-boder-button"
                >
                  Cancel
                </Button>
                {state.suspense ? (
                  <CircularProgress size="2rem" color="primary" />
                ) : (
                  <Button
                    size="large"
                    variant="contained"
                    color="primary"
                    type="submit"
                    className="blue-button"
                  >
                    Update
                  </Button>
                )}
              </Box>
            </Grid>
          </Grid>
        </Box>
      ) : (
        <Box p={2}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6} lg={4} xl={4}>
              <InfoItem
                label="Name"
                value={profile.firstname + ", " + profile.lastname}
                capitalize={true}
              />
            </Grid>
            <Grid item xs={12} md={6} lg={4} xl={4}>
              <InfoItem label="Email" value={profile.email} />
            </Grid>
            <Grid item xs={12} md={6} lg={4} xl={4}>
              <InfoItem label="Phone" value={profile.phone} />
            </Grid>
            <Grid item xs={12} md={6} lg={8}>
              <InfoItem
                label="Address"
                value={profile.address + ", " + profile.address2}
              />
            </Grid>
            <Grid item xs={12} md={6} lg={4} xl={4}>
              <InfoItem label="Role" value={profile.roles} />
            </Grid>
            <Grid item xs={12} md={6} lg={4} xl={4}>
              <InfoItem label="City" value={profile.city} />
            </Grid>
            <Grid item xs={12} md={6} lg={4} xl={4}>
              <InfoItem label="Zip Code" value={profile.zipcode} />
            </Grid>
            <Grid item xs={12} md={6} lg={4} xl={4}>
              <InfoItem label="State" value={profile.state} />
            </Grid>
            <Grid item xs={12} md={6} lg={4} xl={4}>
              <InfoItem label="Country" value={profile.country} />
            </Grid>
            <Grid item xs="auto" md="auto" lg="auto">
              <Button
                size="medium"
                variant="contained"
                color="secondary"
                onClick={() => {
                  localDispatch({ type: "EDIT-MODE" });
                }}
                disabled={/^trial_user$/i.test(profile.roles) ? true : false}
                className="blue-button"
              >
                Edit
              </Button>
            </Grid>
          </Grid>
        </Box>
      )}
    </Paper>
  );
}

function InfoItem({ label, value, capitalize = false }) {
  return (
    <Box display="flex" sx={{ columnGap: 1 }}>
      <Typography style={{ fontWeight: 600, color: "rgb(52, 71, 103)" }}>
        {label} :
      </Typography>
      <Typography
        style={{
          textTransform: capitalize ? "capitalize" : "none",
          color: "#7b809a",
        }}
      >
        {value}
      </Typography>
    </Box>
  );
}

function getUpdatableData(data) {
  return {
    firstname: data.firstname,
    lastname: data.lastname,
    phone: data.phone,
    address: data.address,
    address2: data.address2,
    city: data.city,
    state: data.state,
    country: data.country,
    zipcode: data.zipcode,
  };
}
